import { Component, OnInit } from '@angular/core';
import { LogService } from '../../services/log.service';
import { ForgotUsernameService } from '../../services/forgot-username.service';

@Component({
  selector: 'app-forgot-username-success',
  template: `
    <div class="card col-12 mt-3 mb-3">
      <div class="card-block">

        <h1 class="card-title">Retrieving Username</h1>

        <div class="col-10 alert alert-success">
          Thank you! Please check your email for your username.
        </div>

        <div class="m-3">
          <a routerLink="/login" routerLinkActive="active">Back to login</a>
        </div>

      </div>
    </div>
  `
})
export class ForgotUsernameSuccessComponent implements OnInit {
  constructor(
    private workflow: ForgotUsernameService,
    private log: LogService
  ) {}

  ngOnInit() {
    this.workflow.reset();
  }
}
